"use strict";

const track = (funnelId, pageId, variationId, restUrl) => {
    const payload = {
        fid: funnelId,
        pid: pageId,
        vid: variationId,
        referer: document.referrer,
        currentUrl: window.location.href
    };

    fetch(restUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    })
        .then((response) => {
            if (!response.ok) {
                return;
            }
            if (response.status === 204) {
                return null;
            }
            return response;
        })
        .then((response) => {
            if (!response) {
                return null;
            }
            return response.json();
        })
        .then((result) => {
            if (!result || !result.data) {
                return;
            }
            if (window.OPFunnelStats) {
                window.OPFunnelStats.queried_object_id = result.data.queried_object_id;
                window.OPFunnelStats.pageview_record_id = result.data.pageview_record_id;
            }
        })
        .catch((error) => {
            return;
        });
}

const init = () => {
    try {
        if (typeof window.OPFunnelStats === 'undefined') {
            return;
        }

        const stats = window.OPFunnelStats;

        if (stats.fid && stats.pid && stats.rest_url) {
            track(stats.fid, stats.pid, stats.vid, stats.rest_url);
        }
    } catch (err) {
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}





